import { render, staticRenderFns } from "./WithdrawModal.vue?vue&type=template&id=96d84eac&scoped=true&"
import script from "./WithdrawModal.vue?vue&type=script&lang=js&"
export * from "./WithdrawModal.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawModal.vue?vue&type=style&index=0&id=96d84eac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d84eac",
  null
  
)

export default component.exports